import React from 'react';
import Typography from '@mui/material/Typography';

/**
 * The part's unit after a quantity: "40 l", "0 l", "2 kpl". Same font size as the
 * number it follows, regular weight, secondary colour, a normal space before it.
 * The raw unit code (what the part register stores), never a translation, so a
 * balance and its unit always agree. A smaller or muted unit reads as "|" or "1".
 */
export default function UnitSuffix({ unit }) {
  return (
    <>
      {' '}
      <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 400, color: 'text.secondary' }}>
        {unit || 'kpl'}
      </Typography>
    </>
  );
}
